import { whiteColor, primaryColor, blackColors, hexToRgb } from 'assets/jss/material-dashboard-pro-react';
import typographyStyle from 'assets/jss/material-dashboard-pro-react/components/typographyStyle';

const linesStyle = (theme) => ({
	center: {
		margin: 'auto',
		display: 'flex',
		alignItems: 'center',
	},
	minusPlus: {
		marginTop: 7,
		marginLeft: 12,
		marginRight: 12,
	},
	plus: {
		color: whiteColor,
		backgroundColor: primaryColor[0],
		borderRadius: '100%',
	},
	inputText: {
		'& input': {
			...((style) => ({ ...style.headingLBold, ...style.brand }))(typographyStyle(theme)),
			textAlign: 'center',
			paddingTop: 11,
			paddingBottom: 7,
		},
	},
	inputContainer: {
		width: 88,
	},
	addMoreLines: {
		color: `${primaryColor[0]} !important`,
	},
	line: {
		display: 'flex',
		alignItems: 'center',
	},
	lineActive: {
		color: primaryColor[0],
	},
	lineInactive: {
		color: blackColors[4],
	},
	lineIcon: {
		marginLeft: 16,
		[theme.breakpoints.down('xs')]: {
			marginLeft: 0,
		},
	},
	fbblineInput: {
		flex: 1,
		display: 'flex',
		position: 'relative',
		flexDirection:'column'
	},
	userNameLabel: {
		padding: '10px 0px',
		borderRadius: '5px',
		minWidth: '200px',
	},
	lineInput: {
		flex: 1,
		marginLeft: 17,
		position: 'relative',
		[theme.breakpoints.down('xs')]: {
			marginLeft: 10,
		},
	},
	subtitle: {
		marginBottom: 24,
	},
	lineNameErrorWrapper: {
		marginTop: '5px',
		marginBottom: '5px',

	},
	loaderWrapper: {
		position: 'absolute',
		width: '100%',
		left: 0,
		height: '100%',
		top: '10px',
		backgroundColor: `rgba(${hexToRgb(whiteColor)}, 0.4)`,
	},
});

export default linesStyle;
